import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

const state = {
  loading: false,
  searching: '',
  user: null,
  userSu: null,
  tokenSu: null,
  token: null,
  userInfo: {
    messages: [],
    notifications: [],
    tasks: []
  }
}

const actions = {
  switchUser ({ commit, state }, { user, token }) {
    commit('setTokenSu', state.token)
    commit('setUserSu', state.user)
    commit('setToken', token)
    commit('setUser', user)
    if (user !== null) {
      if (user.roles.includes('ADMINISTRADOR')) {
        router.push({ name: 'secure.admin' })
      }
      if (user.roles.includes('GESTION')) {
        router.push({ name: 'secure.gestion' })
      }
      if (user.roles.includes('CLIENTE')) {
        router.push({ name: 'secure.cliente' })
      }
    }
  },
  updateUser ({ commit }, { user, token }) {
    commit('setToken', token)
    commit('setUser', user)
    if (user !== null) {
      if (user.roles.includes('ADMINISTRADOR')) {
        router.push({ name: 'secure.admin' })
      }
      if (user.roles.includes('GESTION')) {
        router.push({ name: 'secure.gestion' })
      }
      if (user.roles.includes('CLIENTE')) {
        router.push({ name: 'secure.cliente' })
      }
    }
  },
  logout ({ commit }) {
    commit('setTokenSu', null)
    commit('setUserSu', null)
    commit('setToken', null)
    commit('setUser', null)
  },
  switchBack ({ commit, state }) {
    let user = state.userSu
    commit('setToken', state.tokenSu)
    commit('setUser', state.userSu)
    commit('setTokenSu', null)
    commit('setUserSu', null)
    if (user !== null) {
      if (user.roles.includes('ADMINISTRADOR')) {
        router.replace({ name: 'secure.admin' })
        console.log('aca')
      }
      if (user.roles.includes('GESTION')) {
        router.replace({ name: 'secure.gestion' })
      }
      if (user.roles.includes('CLIENTE')) {
        router.replace({ name: 'secure.cliente' })
      }
    }
  },
  setLoading ({ commit }, value) {
    commit('setLoading', value)
  }
}

const mutations = {
  setLoading (state, value) {
    state.loading = value
  },
  globalSearching (state) {
    state.searching = state.searching === '' ? 'loading' : ''
  },
  setUser (state, user) {
    state.user = user
  },
  setToken (state, token) {
    state.token = token
  },
  setUserSu (state, user) {
    state.userSu = user
  },
  setTokenSu (state, token) {
    state.tokenSu = token
  },
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  }
}

const getters = {
  user: state => {
    return state.user
  },
  loading: state => {
    return state.loading
  },
  inSudo: state => {
    return state.userSu !== null
  },
  logged: state => {
    return state.user !== null
  },
  loggedAdmin: state => {
    return (state.user !== null && state.user.roles.includes('ADMINISTRADOR'))
  },
  menus: state => {
    if (state.user == null) {
      return []
    }
    const adminItems = [
      {
        heading: 'Bienvenido'
      },
      {
        icon: 'dashboard',
        text: 'Inicio',
        link: '/admin/dashboard'
      },
      {
        icon: 'people',
        text: 'Usuarios',
        link: '/admin/usuarios'
      },
      {
        icon: 'store_mall_directory',
        text: 'Tomadores',
        link: '/admin/clientes'
      },
      {
        icon: 'business',
        text: 'Aseguradoras',
        link: '/admin/aseguradoras'
      },
      {
        icon: 'assignment_ind',
        text: 'Asesores',
        link: '/admin/asesores'
      },
      {
        icon: 'call_split',
        text: 'Derivadores',
        link: '/admin/derivadores'
      },
      {
        icon: 'library_books',
        text: 'Pólizas',
        link: '/admin/polizas'
      },
      {
        icon: 'access_alarm',
        text: 'Notificaciones',
        link: '/admin/notificaciones'
      },
      {
        icon: 'tune',
        text: 'Configuración',
        link: '/admin/configuracion'
      }
    ]

    const gestionItems = [
      {
        heading: 'Bienvenido'
      },
      {
        icon: 'dashboard',
        text: 'Inicio',
        link: '/gestion/dashboard'
      },
      {
        icon: 'store_mall_directory',
        text: 'Tomadores',
        link: '/gestion/clientes'
      },
      {
        icon: 'library_books',
        text: 'Pólizas',
        link: '/gestion/polizas'
      },
      {
        icon: 'access_alarm',
        text: 'Notificaciones',
        link: '/gestion/notificaciones'
      }
    ]

    const clienteItems = [
      {
        heading: 'Bienvenido'
      },
      {
        icon: 'library_books',
        text: 'Pólizas',
        link: '/cliente/polizas'
      }
    ]
    if (state.user.roles.includes('ADMINISTRADOR')) {
      return adminItems
    }
    if (state.user.roles.includes('GESTION')) {
      return gestionItems
    }
    if (state.user.roles.includes('CLIENTE')) {
      return clienteItems
    }
    return []
  },
  paginas: state => {
    const paginas = [
      {
        heading: 'Bienvenido'
      },
      {
        icon: 'dashboard',
        text: 'Inicio',
        link: '/'
      },
      {
        icon: 'business',
        text: 'Seguros para Empresas',
        link: '/empresas'
      },
      {
        icon: 'assignment_ind',
        text: 'Seguros para Personas',
        link: '/personas'
      },
      {
        icon: 'email',
        text: 'Contacto',
        link: '/contacto'
      },
      {
        icon: 'security',
        text: 'Area Clientes',
        link: '/login'
      }
    ]
    return paginas
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js